// extracted by mini-css-extract-plugin
export default {"storyTimeline":"c-a_gp","storyTimeline__item":"c-a_gq","storyTimeline__item_complete":"c-a_gr","storyTimeline__item_withProgress":"c-a_gs"};